<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        TME
                    </a>
                </li>
                <li class="nav-item" v-if="false">
                    <a class="nav-link" href="#" :class="aba == 'lista' ? 'active' : ''" @click.prevent="abrir('lista')" >
                        Lista
                    </a>
                </li>
            </ul>
        </div>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load(1)" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Unidades..."
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="checkbox-group"
                            label="Agrupar por Recepção"
                            v-model="filtro.agrupar_recepcao" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="time"
                            icon="fas fa-greater-than-equal fa-fw"
                            v-model="filtro.hora_inicio" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            type="time"
                            icon="fas fa-less-than-equal fa-fw"
                            v-model="filtro.hora_fim" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa-solid fa-object-group"
                            placeholder="Agrupar por..."
                            :optionsList="[
                                { value: 'atendimento', label: 'Atendimento' },
                                { value: 'especialidade', label: 'Especialidade' },
                                { value: 'paciente', label: 'Paciente' },
                                { value: 'procedimento', label: 'Procedimento' },
                                { value: 'medico', label: 'Profissional' },
                                { value: 'operadora', label: 'Operadora' },
                                { value: 'recepcao', label: 'Recepção' },
                                { value: 'unidade', label: 'Unidade' },
                            ]"
                            optionsData="value"
                            optionsDisplay="label"
                            v-model="filtro.agrupar_por" />
                    </div>
                </div>
            </div>
            
        </div>

        <div class="mb-3"></div>

        <div v-if="aba == 'visao'">

            <az-empty-state icon="fa-solid fa-stopwatch" msg="Nenhuma unidade identificada." v-if="!dados" />

            <template v-else>

                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Espera</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" id="hora-tab" data-toggle="tab" href="#hora" role="tab" aria-controls="hora" aria-selected="true">Evolução</a>
                    </li>
                    <li class="nav-item" role="presentation" v-if="dados && dados.esperas">
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Esperando</a>
                    </li>
                </ul>

                <div class="tab-content" id="myTabContent">
                    <!-- Tempo de Espera -->
                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                        <az-empty-state icon="fa-solid fa-stopwatch" msg="Nenhuma unidade identificada." v-if="!(dados && dados.tempos && dados.tempos.length)" />

                        <template v-else>
            
                            <table class="table table-hover bg-white">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th class="text-right">Qtd Recep</th>
                                        <th class="text-right">TME Recep</th>
                                        <th class="text-right">TMA Recep</th>
                                        <th class="text-right">Qtd {{ titulo_atend }}</th>
                                        <th class="text-right">TME {{ titulo_atend }}</th>
                                        <th class="text-right">TMA {{ titulo_atend }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(tempo, itx) in dados.tempos" :key="itx">
                                        <td>
                                            {{ tempo.descricao }}
                                            <span class="small text-muted ml-2" v-if="tempo.recepcao">{{ tempo.recepcao.st_nome }}</span>
                                        </td>
                                        <td class="text-right">{{ tempo.qtde_recep }}</td>
                                        <td class="text-right">{{ tempo.tme_recep_formatado }}</td>
                                        <td class="text-right">{{ tempo.tma_recep_formatado }}</td>
                                        <td class="text-right">{{ tempo.qtde_coleta }}</td>
                                        <td class="text-right">{{ tempo.tme_atend_formatado }}</td>
                                        <td class="text-right">{{ tempo.tma_atend_formatado }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            
                        </template>

                    </div>

                    <!-- Evolução por Hora -->
                    <div class="tab-pane fade" id="hora" role="tabpanel" aria-labelledby="hora-tab">

                        <div class="alert alert-info">Referente a hora de check-in do paciente.</div>

                        <div class="card-deck mb-3">

                            <div class="card card-dash dashcard" style="padding: 0px;">
                                <div class="card-body text-right">
                                    <div v-if="dados">
                                        <Chart type="bar" :data="info_grafico (dados.tempos_por_hora, 'quebra_hora', 'tme_recep_valor', 'TME Recepção')" 
                                        :options="{ 
                                            scales: { 
                                                xAxes: [{ 
                                                    stacked: true, 
                                                    barThickness: 24, 
                                                    maxBarThickness: 32,
                                                }], 
                                                yAxes: [{ 
                                                    stacked: true,
                                                    ticks: {
                                                        callback: function(value, index, values) {
                                                            return value; // ( Math.round(value * 100) / 100 ) + ' minuto(s)'; 
                                                        }
                                                    }
                                                }] 
                                            } 
                                        }" />
                                    </div>
                                </div>
                            </div>

                            <div class="card card-dash dashcard" style="padding: 0px;">
                                <div class="card-body text-right">
                                    <div v-if="dados">
                                        <Chart type="bar" :data="info_grafico (dados.tempos_por_hora, 'quebra_hora', 'qtde_recep', 'Qtde Recepção')" 
                                        :options="{ 
                                            scales: { 
                                                xAxes: [{ 
                                                    stacked: true, 
                                                    barThickness: 24, 
                                                    maxBarThickness: 32,
                                                }], 
                                                yAxes: [{ 
                                                    stacked: true,
                                                    ticks: {
                                                        callback: function(value, index, values) {
                                                            return value; // ( Math.round(value * 100) / 100 ) + ' minuto(s)'; 
                                                        }
                                                    }
                                                }] 
                                            } 
                                        }" />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="card-deck mb-3">

                            <div class="card card-dash dashcard" style="padding: 0px;">
                                <div class="card-body text-right">
                                    <div v-if="dados">
                                        <Chart type="bar" :data="info_grafico (dados.tempos_por_hora, 'quebra_hora', 'tme_atend_valor', 'TME ' + titulo_atend)"  
                                        :options="{ 
                                            scales: { 
                                                xAxes: [{ 
                                                    stacked: true, 
                                                    barThickness: 24, 
                                                    maxBarThickness: 32,
                                                }], 
                                                yAxes: [{ 
                                                    stacked: true,
                                                    ticks: {
                                                        callback: function(value, index, values) {
                                                            return value; // ( Math.round(value * 100) / 100 ) + ' minuto(s)'; 
                                                        }
                                                    }
                                                }] 
                                            } 
                                        }" />
                                    </div>
                                </div>
                            </div>

                            <div class="card card-dash dashcard" style="padding: 0px;">
                                <div class="card-body text-right">
                                    <div v-if="dados">
                                        <Chart type="bar" :data="info_grafico (dados.tempos_por_hora, 'quebra_hora', 'qtde_coleta', 'Qtde ' + titulo_atend)"  
                                        :options="{ 
                                            scales: { 
                                                xAxes: [{ 
                                                    stacked: true, 
                                                    barThickness: 24, 
                                                    maxBarThickness: 32,
                                                }], 
                                                yAxes: [{ 
                                                    stacked: true,
                                                    ticks: {
                                                        callback: function(value, index, values) {
                                                            return value; // ( Math.round(value * 100) / 100 ) + ' minuto(s)'; 
                                                        }
                                                    }
                                                }] 
                                            } 
                                        }" />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- Tempo Esperando Recepção -->
                    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab" v-if="dados && dados.esperas">

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <table class="table table-hover bg-white">
                                    <thead>
                                        <tr>
                                            <th>Unidade</th>
                                            <th class="text-right">Qtd</th>
                                            <th class="text-right">Recepção</th>
                                            <th class="text-right">Máx</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(espera_unidade, iex) in dados.esperas.recep">
                                            <tr  :key="iex" :class="espera_unidade.cor ? 'table-' + espera_unidade.cor : ''" v-if="true">
                                                <td>
                                                    <a href="#" @click.prevent="espera_unidade.sintetico = !espera_unidade.sintetico">
                                                        {{ espera_unidade.unidade_operacao.st_nome }}
                                                    </a>
                                                    <span class="small text-muted ml-2" v-if="espera_unidade.recepcao">{{ espera_unidade.recepcao.st_nome }}</span>
                                                </td>
                                                <td class="text-right">{{ espera_unidade.qtde }}</td>
                                                <td class="text-right">{{ espera_unidade.tme_formatado }}</td>
                                                <td class="text-right">{{ espera_unidade.max_formatado }}</td>
                                            </tr>

                                            <template v-if="!espera_unidade.sintetico">
                                                <tr :key="'D' + iex">
                                                    <td colspan="4">
                                                        <table class="table table-sm small">
                                                            <thead>
                                                                <tr>
                                                                    <th>Pacientes</th>
                                                                    <th class="text-right">CheckIn</th>
                                                                    <th class="text-right">Marcação</th>
                                                                    <th class="text-right">Chamado</th>
                                                                    <th class="text-right">Espera</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, iix) in espera_unidade.items" :key="iix" :class="item.st_cor ? 'table-' + item.st_cor : ''">
                                                                    <td>
                                                                        <a href="#" @click.prevent="abrir_atendimento(item)" class="card-link">
                                                                            {{ item.nome_paciente }}
                                                                        </a>
                                                                        <i class="fa-brands fa-product-hunt text-danger" v-if="item.fl_preferencial"></i>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span v-if="item.dt_checkin">{{ item.dt_checkin.slice(11,16) }}</span>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span v-if="item.dt_checkin && item.dt_checkin.slice(0, 16) != item.dt_inicio.slice(0, 16)">
                                                                            {{ item.dt_inicio.slice(11,16) }}
                                                                        </span>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span v-if="item.dt_chamada_recepcao">
                                                                            {{ item.dt_chamada_recepcao.slice(11,16) }}
                                                                        </span>
                                                                    </td>
                                                                    <td class="text-right">{{ item.max_formatado }}</td>
                                                                </tr>                
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <div class="col col-12 col-md-6">
                                <table class="table table-hover bg-white">
                                    <thead>
                                        <tr>
                                            <th>Unidade</th>
                                            <th class="text-right">Qtd</th>
                                            <th class="text-right">{{ titulo_atend }}</th>
                                            <th class="text-right">Máx</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(espera_unidade, iex) in dados.esperas.atend">
                                            <tr :key="iex" :class="espera_unidade.cor ? 'table-' + espera_unidade.cor : ''" v-if="true">
                                                <td>
                                                    <a href="#" @click.prevent="espera_unidade.sintetico = !espera_unidade.sintetico">
                                                        {{ espera_unidade.unidade_operacao.st_nome }}
                                                    </a>
                                                    <span class="small text-muted ml-2" v-if="espera_unidade.recepcao">{{ espera_unidade.recepcao.st_nome }}</span>
                                                </td>
                                                <td class="text-right">{{ espera_unidade.qtde }}</td>
                                                <td class="text-right">{{ espera_unidade.tme_formatado }}</td>
                                                <td class="text-right">{{ espera_unidade.max_formatado }}</td>
                                            </tr>

                                            <template v-if="!espera_unidade.sintetico">
                                                <tr :key="'D' + iex">
                                                    <td colspan="4">
                                                        <table class="table table-sm small">
                                                            <thead>
                                                                <tr>
                                                                    <th>Pacientes</th>
                                                                    <th class="text-right">Fim Recep</th>
                                                                    <th class="text-right">Marcação</th>
                                                                    <th class="text-right">Espera</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, iix) in espera_unidade.items" :key="iix" :class="item.st_cor ? 'table-' + item.st_cor : ''">
                                                                    <td>
                                                                        <a href="#" @click.prevent="abrir_atendimento(item)" class="card-link">
                                                                            {{ item.nome_paciente }}
                                                                        </a>
                                                                        <i class="fa-brands fa-product-hunt text-danger" v-if="item.fl_preferencial"></i>

                                                                        <span class="badge badge-light"
                                                                            v-else-if="item.paciente.cadastro && item.paciente.cadastro.idade_anos" title="idade do paciente">
                                                                            {{ item.paciente.cadastro.idade_anos }}a
                                                                        </span>  

                                                                        <span v-if="item.paciente && item.paciente.sinalizadores" class="ml-1">
                                                                            <span v-for="(sinal, isx) in item.paciente.sinalizadores" :key="isx" :title="sinal.sinalizador.search">
                                                                                <i class="fa-fw" :class="( sinal.sinalizador.st_icon ? sinal.sinalizador.st_icon : 'fas fa-flag') + ' text-'  + sinal.sinalizador.st_cor" aria-hidden="true"></i>
                                                                            </span>
                                                                        </span>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span v-if="item.dt_fim_atend_recep">{{ item.dt_fim_atend_recep.slice(11,16) }}</span>
                                                                    </td>
                                                                    <td class="text-right">{{ item.dt_inicio.slice(11,16) }}</td>
                                                                    <td class="text-right">{{ item.max_formatado }}</td>
                                                                </tr>                
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <pre v-if="false">{{ dados.esperas }}</pre>                       
                    </div>

                </div>

            </template>

            <br><br><br><br><br>
            
        </div>

        <div v-else>

            <az-empty-state icon="fa-solid fa-stopwatch" msg="Nenhuma unidade identificada." v-if="!dados" />

            <pre v-else-if="false">{{ dados }}</pre>

        </div>

    </div>

</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            filtro: { 
                periodo: 'h',
                id_unidade_operacao: "", 
                hora_inicio: "00:00",
                hora_fim: "23:59",
                agrupar_por: 'unidade', 
            },
            ja_buscou: false, 
            page: 1, 
            dados: null, 
        };
    },

    components: { 
        AzPeriodo,
        AzInput,
        AzEmptyState,  
    },

    props: ['aba'],

    computed: { 
        titulo_atend: function () { 
            if ( window.redir == 'dnagenetica' ) { 
                return 'Coleta';
            } else { 
                return 'Atend';
            }
        },
    },

    methods: { 
        info_grafico (lista, label, value, titulo = null) { 
            if ( !lista )
                return { labels: [] };

            let valores = lista.map(item => { 
                return { 
                    label: ( item[label] && item[label] != 'null' ) ? item[label] : '?',
                    value: item[value], 
                }
            })

            valores = _.orderBy(valores, 'label', 'asc');

            let grafico = {
				labels: _.map(valores, (item) => ( ( item.label && item.label != 'null' ) ? item.label : '?' )),
				datasets: [
					{
						label: titulo ? titulo : 'Total',
                        backgroundColor: 'rgba(0,255,0,0.8)',
                        borderColor: '#33CC11',
                        fill: true, 
						data: _.map(valores, (item) => item.value)
					}
				]
            };
            
            return grafico;

        },

        abrir_atendimento (item) { 
            if ( item.id_atendimento ) { 
                this.$util.abrir_atendimento(this, item.id_atendimento);
            } else { 
                this.$router.push({ name: 'recepcao', params: { search: 'M' + item.id_marcacao } });
            }
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/tempos/' + aba });
            }

            this.set_bread(aba);

            this.ja_buscou = false;
        },

        load(page = null) { 
            this.$util.load(this, { 
                service: 'tempos',
                func: 'index',
                parms: { 
                    ...this.filtro, 
                    page: this.page,
                    size: 100, 
                }, 
                loadTo: res => { 
                    this.dados = res;
                    
                }
            }),

            console.log(page);
        },

        set_bread (aba = null) { 

            if ( !aba )
                aba = this.aba;

            if ( aba == 'visao' ) { 

                this.$store.commit("setBreadcrumb", [
                    { name: "Tempos", path: "/tempos/visao" },
                    { name: "Visão Geral", path: "/tempos/visao" },
                ]);

            } else { 

                this.$store.commit("setBreadcrumb", [
                    { name: "Tempos", path: "/tempos/visao" },
                    { name: "Lista", path: "/tempos/lista" },
                ]);

            }

        },
    },

    mounted() { 
        this.set_bread();
    }

}
</script>

